export default __webpack_public_path__ + "static/media/brdados.573c6021.svg";